<template>
  <div v-loading="!goodDetailReady" style="min-width:600px;min-height:400px;background: white;">
  <div ref="imgcontainer" v-if="goodDetailReady" class="detail-wrapper" :class="{'popup':isPopUp=='1'}">
    <div class="imgdivwrapper" :class="{'special':!isNoSpecialImage}" :style="{ width: containerWidth + 'px' }">
        <template v-if="selectGoodInfo.enable_alternate_images=='1'">
          <template v-if="selectGoodInfo.alternate_image_list.length">
            <el-carousel v-if="totalBanner>1" indicator-position="none" class="article-caroul" :autoplay="false" style="height:100%;" @change="caroulChange">
              <el-carousel-item v-for="(item,index) in selectGoodInfo.alternate_image_list" :key="index">
                <img @load="handleImageLoad($event,index)" @error="handleImageError" referrerpolicy="no-referrer" :src="item.small" style="width:100%;object-fit: contain;"/>
              </el-carousel-item>
            </el-carousel>
            <div v-else>
                <img @load="handleImageLoad($event,0)" @error="handleImageError" referrerpolicy="no-referrer" :src="selectGoodInfo.alternate_image_list[0].small" style="width:100%;height:100%;object-fit: contain;border-radius: 3px;"/>
            </div>
          </template>
          <template v-else>
              <div style="width:100%;height:100%;">
                  <div class="plh_img" style="width:100%;height:100%;padding:0 5px">
                    <img @load="handleImageLoad($event,0,600)" class="plh_img_walk" :src="selectGoodInfo[goodDetail.unique_param][0].url" style="height:200px;"/>
                  </div>
              </div>
          </template>
        </template>
        <template v-else>
            <el-carousel v-if="totalBanner>1" indicator-position="none" class="article-caroul" :autoplay="false" style="height:100%;" @change="caroulChange">
              <el-carousel-item v-for="(item,index) in selectGoodInfo.images" :key="index">
                <img @load="handleImageLoad($event,0)" @error="handleImageError" referrerpolicy="no-referrer" :src="item" style="width:100%;object-fit: contain;"/>
              </el-carousel-item>
            </el-carousel>
            <div v-else>
                <img @load="handleImageLoad($event,0)" @error="handleImageError" referrerpolicy="no-referrer" :src="selectGoodInfo.images[0]" style="width:100%;object-fit: contain;"/>
            </div>
        </template>
      <div v-if="totalBanner>1" style="z-index: 999;position:absolute;top:10px;right:10px;background:#ccc;color:white;border-radius: 3px;padding: 5px;">
        {{ imageIndex+1 }}/{{ totalBanner }}
      </div>
    </div>
    <div style="width:460px;padding:10px 24px 24px;position: relative;border-left:1px solid rgba(0, 0, 0, 0.08)">
      <div class="right-article-detail" :class="{'popup':isPopUp=='1'}">
        <h3 style="margin-bottom:10px;">
          {{ showProductName(selectGoodInfo) }}
        </h3>
        <div class="right-detail-header">
          <!--<div class="right-detail-header-image">
            <template v-if="selectGoodInfo.enable_alternate_images==1">
              <img v-if="selectGoodInfo.alternate_image_list.length" :src="selectGoodInfo.alternate_image_list[0].small" style="width:75px;height:75px;object-fit: contain;"/>
              <div class="plh_img" style="height:75px;" v-else>
                <div class="plh_img_walk" :style="{backgroundImage:'url('+(selectGoodInfo[goodDetail.unique_param])[0].url+')'}"></div>
              </div>
            </template>
            <img v-else :src="selectGoodInfo.images[0]" style="width:75px;height:75px;object-fit: contain;"/>          
          </div>-->
          <div>
            <template v-if="selectMerchant.loadStatus==true">
              <i class="el-icon-loading"></i>
            </template>
            <template v-else>
              <div v-if="selectGoodInfo.isInShop==false">
                <label>已下架</label>
              </div>
              <div v-else style="padding:5px 0;height:100%;display: flex;flex-direction: column;justify-content: space-between;">
                <div>
                    <del v-if="currentPriceInfo.price!='--' && currentPriceInfo.price != currentPriceInfo.discounted_price" style="color:#b0b4bf">{{currentPriceInfo.currency_symbol}}{{currentPriceInfo.price+' '}}</del><span class="product-price title" :class="{'discounted':currentPriceInfo.price != currentPriceInfo.discounted_price}">{{currentPriceInfo.price!='--'?currentPriceInfo.currency_symbol:''}}{{currentPriceInfo.discounted_price}}</span><span style="color:rgb(176, 180, 191);font-size: 12px;">{{ ' '+currentPriceInfo.currency }}</span>
                </div>
                <div style="color:#999;font-size:28rpx;margin-top:10px;">
                  {{ selectInfo.unique_param_value }}{{ ' '+selectInfo.vice_param_value }}{{ ' '+selectMerchant.name }}
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="right-detail-body" style="background:#fafafa">
          <div v-if="groupName!='' & isGroupBehind==true">
            <div style="font-size:28rpx;font-weight: bold;">
              {{ getSpecName(groupName) }}
            </div>
            <div style="display: flex;flex-wrap: wrap;margin-top:5px;padding:10px 0">
              <div class="vice-params-item" :class="{'active':curGroupName==group}" v-for="(group,index) in groups" @click="changeGroup(group)" :key="index">
                {{ group }}
              </div>
            </div>
          </div>
          <div style="padding:17px 0 0 15px;">
            <div style="padding:5px 0;display: flex;align-items: center;justify-content: space-between;">
              <label class="spec-name-text">{{ getSpecName(goodDetail.unique_param) }}</label>
              <div style="margin-right:15px;display: flex;">
                <div class="spec-button" style="border-right:none;" :class="{'active': sort_type == 0}" @click="sort_type=0">
                  A-Z
                </div>
                <div class="spec-button" :class="{'active': sort_type == 1}" @click="sort_type=1">
                  价格↓
                </div>
              </div>
            </div>
            <div v-if="canHidden" @click="isShowAll=!isShowAll" style="margin-top:5px;background: white;padding:10px;text-align: center;">
              <text style="font-size:11px;color:#333;">
                {{ isShowAll?'已显示此商家未上架商品,点击隐藏':'已隐藏此商家未上架商品,点击显示' }}
              </text>
              <i :class="{'isShowAll':'el-icon-arrow-up','!isShowAll':'el-icon-arrow-down'}"></i>
            </div>
            <template v-if="sort_type==0">
              <div style="padding:10px 0;display: flex;flex-wrap: wrap;">
                <template v-for="item in filterSameGoods">
                  <div class="unique-params-item" :class="{'active':item.id==selectGoodInfo.id}" v-show="!canHidden || (canHidden && item.isInShop==true) || (canHidden && isShowAll)" @click="setPrimarySpec(item,true,false)">
                    <div class="unique-params-item-image" :class="{'notAvailable':item.isInShop==false}">
                      <template v-if="item.enable_alternate_images==1">
                        <img v-if="item.alternate_image_list.length" :src="item.alternate_image_list[0].small" style="width:75px;height:75px;object-fit: contain;"/>
                        <div class="plh_img" style="height:75px;" v-else>
                          <div class="plh_img_walk" :style="{backgroundImage:'url('+(item[goodDetail.unique_param])[0].url+')'}"></div>
                        </div>
                      </template>
                      <img v-else :src="item.cover_image.small" style="width:75px;height:75px;object-fit: contain;"/>          
                    </div>
                    <div class="unique-params-text" :class="{'notAvailable':item.isInShop==false}">
                      {{ (item[goodDetail.unique_param])[0].value }}
                    </div>
                  </div>
                </template>
              </div>
            </template>
            <template v-else>
              <div v-for="(price,index) in showPriceGroup" :key="index">
                <div>
                  <template v-if="price.discounted_price!='--'">
                    <label style="margin-right:3px;font-size:15px;" :class="{'discounted_price':price.discounted_price!=price.price}">
                      {{ currentPriceInfo.currency_symbol }}{{ price.discounted_price }}
                    </label>
                    <label>{{ currentPriceInfo.currency }}</label>
                  </template>
                  <template v-else>
                    --
                  </template>
                </div>
                <div style="padding:10px 0;display: flex;flex-wrap: wrap;">
                  <template v-for="item in priceGroup_filterSameGoods(price)">
                    <div class="unique-params-item" :class="{'active':item.id==selectGoodInfo.id}" v-show="!canHidden || (canHidden && item.isInShop==true) || (canHidden && isShowAll)" @click="setPrimarySpec(item,true,false)">
                      <div class="unique-params-item-image" :class="{'notAvailable':item.isInShop==false}">
                        <template v-if="item.enable_alternate_images==1">
                          <img v-if="item.alternate_image_list.length" :src="item.alternate_image_list[0].small" style="width:75px;height:75px;object-fit: contain;"/>
                          <div class="plh_img" style="height:150px;" v-else>
                            <div class="plh_img_walk" :style="{backgroundImage:'url('+(item[goodDetail.unique_param])[0].url+')'}"></div>
                          </div>
                        </template>
                        <img v-else :src="item.cover_image.small" style="width:75px;height:75px;object-fit: contain;"/>          
                      </div>
                      <div class="unique-params-text" :class="{'notAvailable':item.isInShop==false}">
                        {{ (item[goodDetail.unique_param])[0].value }}
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </template>
          </div>
          <div style="padding:10px 15px" v-for="(vice_arr_item,index) in vice_arr" :key="index">
            <div style="display:flex;justify-content: space-between;">
              <div class="spec-name-text">{{ getSpecName(vice_arr_item) }}</div>
              <div v-if="goodDetail.unit_display && vice_arr_item=='size'">
                {{ goodDetail.unit_display }}
              </div>
            </div>
            <div style="display:flex;flex-wrap: wrap;padding:10px 0;">
              <template v-for="(vice,index) in selectGoodInfo['real_'+vice_arr_item+'_list']">
                <div v-if="vice.isShow==true" @click="setSpec(vice_arr_item,vice)" class="vice-params-item" 
                :class="{'active':vice.showValue==selectGoodInfo['select_'+vice_arr_item],'notAvailable':!vice.available}">
                  {{ vice.showValue.replace('#','-') }}
                </div>
              </template>
            </div>
          </div>
          <div v-if="groupName!='' & isGroupBehind==false">
            <div style="font-size:28rpx;font-weight: bold;">
              {{ getSpecName(groupName) }}
            </div>
            <div style="display: flex;flex-wrap: wrap;margin-top:5px;padding:10px 0">
              <div class="vice-params-item" :class="{'active':curGroupName==group}" v-for="(group,index) in groups" @click="changeGroup(group)" :key="index">
                {{ group }}
              </div>
            </div>
          </div>
          <div style="padding: 0 15px;">
            <div style="padding:5px 0 10px;display: flex;justify-content: space-between;">
              <label>商家</label>
            </div>
            <template v-for="(merchant,index) in merchantList">
              <div class="merchant-item" :class="{'active':merchant.id==selectMerchant_ID}" @click="setMerchant(merchant)" v-if="merchant.isShow==true">
                <div class="merchant-nostock" v-if="merchant.loadStatus==false && merchant.isInShop==true && computedStock(merchant)">
                  无货
                </div>
                <div>
                  <img class="flag" :src="`https://pic.joyorders.com/country/${merchant.country.toLowerCase()}.png`" alt="country"/>
                  <label style="cursor: pointer;">{{ merchant.name }}</label>
                </div>
                <template v-if="merchant.loadStatus==false">
                  <div v-if="merchant.isInShop==false">
                    已下架
                  </div>
                  <div v-else>
                    <del v-if="merchantPriceInfo(merchant).price!='--' && merchantPriceInfo(merchant).price != merchantPriceInfo(merchant).discounted_price" style="color:#b0b4bf">{{merchantPriceInfo(merchant).currency_symbol}}{{merchantPriceInfo(merchant).price+' '}}</del><span class="product-price" :class="{'discounted':merchantPriceInfo(merchant).price != merchantPriceInfo(merchant).discounted_price}">{{merchantPriceInfo(merchant).price!='--'?merchantPriceInfo(merchant).currency_symbol:''}}{{merchantPriceInfo(merchant).discounted_price}}</span><span style="color:#333;font-size: 11px;">{{ ' '+merchantPriceInfo(merchant).currency }}</span>
                  </div>
                </template>
                <i v-else class="el-icon-loading"></i>
              </div>
            </template>
            <div v-if="otherMerList.length" class="merchant-item" @click="isShowOtherM=!isShowOtherM">
              <label>{{ isShowOtherM?'已显示此商品未上架商家':'已隐藏此商品未上架商家' }}</label>
              <label>{{ isShowOtherM?'隐藏':'查看' }}</label>
            </div>
            <div v-if="isShowOtherM">
              <div class="merchant-item" v-for="(merchant,idx) in otherMerList" :key="idx" :style="getStyle(merchant)">
                <div>
                  <img :src="merchant.flag" style="width:20px;" />
                  <label style="margin-left:8px;">{{ merchant.name }}</label>
                </div>
                <div>
                  未上架
                </div>
              </div>
            </div>
          </div>
          <h4 v-if="isPopUp=='1'" style="margin:10px 0;text-align: center;;cursor: pointer;color:#666" @click="handleDetail">
            查看商品详情
          </h4>
        </div>
      </div>
    </div>
  </div>
  <div v-if="isPopUp!='1'">
            <p class="goodDescription" v-html="selectGoodInfo.description_cn"></p>
            <p class="goodDescription" v-html="selectGoodInfo.description"></p>
            <div class="desc_content" v-if="mul_s_table.length">
              <div style="display:flex;justify-content: center;">
                <template v-for="(m,index) in mul_s_table">
                  <div class="s-tab-name" :class="{'active':cur_s_table==index}" @click="cur_s_table=index">
                    <span>
                      {{ m.name }}
                      <label style="color:#333;margin:0 5px;" v-if="index<mul_s_table.length-1">|</label>
                    </span>
                  </div>
                </template>
              </div>
              <template v-for="(m,index) in mul_s_table">
                <div class="size_table" v-show="cur_s_table==index" v-html="m.c"></div>
              </template>
            </div>
          </div>
  </div>
</template>

<script>
import api from '../services/api.js'
import { default_crawler,KEYS } from '../services/constant.js'

export default {
  name: 'ProductDetail',
  created() {
    if (document.body.clientWidth < 1024) {
      this.mobiletype = true
    }
  },
  data () {
    return {
      isNoSpecialImage:true,
      cur_s_table:0,
      mul_s_table:[],
      price_map:new Map(),
      multipleStockMetrix:{},
      validT:{},
      sort_type:0,
      goodDetailReady:false,
      imageIndex:0,
      containerWidth:450,
      units:[],
      goodDetail:{},
      sameGoods:[],
      vice_arr:[],
      selectMerchant:{},
      selectGoodInfo:{},
      groupName:'',
      isGroupBehind:false,
      curGroupName:'',
      isShowAll:true,
      merchantList:[],
      isShowOtherM:false,
      otherMerList:[],
      totalMerlist:[],
      hPNumberLimit:8,
      hNNumberLimit:4,
      showPriceGroup:[]
    }
  },
  props:['productId','merchantId','isPopUp'],
  watch:{
    productId(){
      this.getDetail();
    }
  },
  computed: {
      filterSameGoods(){
        if(this.groupName){
          return this.sameGoods.filter((g)=>{
            return g[this.groupName]==this.curGroupName
          })
        }
        else
          return this.sameGoods
      },
      priceGroup_filterSameGoods(){
        return price =>{
          let m = this.selectMerchant.stockMetrix;
          if(m){
            return this.filterSameGoods.filter((g)=>{
              let default_spec = Object.keys(m)[0]
              let o = m[default_spec]
              let spec = this.selectGoodInfo['select_'+this.goodDetail.vice_param];
              if(spec)
                o = m[spec];
              if(o){
                let o_sku = o[g.sku];
                if(o_sku){
                  let d_price = o_sku.discounted_price;
                  return d_price == price.discounted_price || (price.discounted_price=='--' && (d_price=='--' || d_price=='-9999.00'))
                }
                else
                  return price.discounted_price=='--'
              }
              else
                return price.discounted_price=='--'
            })
          }
          else
            return this.filterSameGoods
        }
      },
      readyConfirm(){
        let r = true;
        for(let i=0;i<this.vice_arr.length;i++){
          if(!this.selectGoodInfo['select_'+this.vice_arr[i]]){
            r = false;
            break;
          }
        }
        return r;
      },
      totalBanner(){
        if(this.selectGoodInfo.enable_alternate_images=='1')
          return this.selectGoodInfo.alternate_image_list.length
        else
          return this.selectGoodInfo.images.length
      },
      selectInfo(){
        let r = {
          unique_param_value:'',
          vice_param_value:''
        }
        if(this.selectGoodInfo){
          let u = this.goodDetail.unique_param;
          if(u){
            let t = this.selectGoodInfo
            r.unique_param_value = t[u][0].value;
          }
          let vi = []
          this.vice_arr.forEach((v)=>{
            if(this.selectGoodInfo['select_'+v])
              vi.push(this.selectGoodInfo['select_'+v])
          })
          r.vice_param_value=vi.length?vi.join(' ').replace('#','-'):''
        }
        return r;
      },
      currentPriceInfo(){
        let m = this.selectMerchant;
        let r = {
            price:'',
            discounted_price:'',
            isInShop:true,
            currency:'',
            currency_symbol:'',
            rmb_price:'',
            rmb_discounted_price:'',
            rmb_currency:'CNY',
            rmb_currency_symbol:'￥'
          };
          if(this.selectGoodInfo && this.selectMerchant){
            if(m.stockMetrix){
              let keys = Object.keys(m.stockMetrix)
              if(this.selectGoodInfo && keys.length>0){
                let default_spec = keys[0];
                let o = m.stockMetrix[default_spec];
                let spec = this.selectGoodInfo['select_'+this.goodDetail.vice_param];
                if(spec)
                  o = m.stockMetrix[spec];
                if(o){
                  let o_sku = o[this.selectGoodInfo.sku];
                  if(o_sku){
                    let p = o_sku.discounted_price;
                    if(p!='--' && p!='-9999.00'){
                      r.price = o_sku.price;
                      r.discounted_price = o_sku.discounted_price
                      r.currency = m.default_currency
                      r.currency_symbol = m.default_currency_symbol
                      r.rmb_price = (parseFloat(r.price)*m.currencyRate).toFixed(2)
                      r.rmb_discounted_price = (parseFloat(r.discounted_price)*m.currencyRate).toFixed(2)
                      r.rmb_currency = 'CNY'
                      r.rmb_currency_symbol = '￥'
                    }
                    else{
                      r.discounted_price='--';
                      r.price='--';
                      r.rmb_price='--';
                      r.rmb_discounted_price='--';
                    }
                  }
                  else{
                    r.discounted_price='--';
                    r.price='--';
                    r.rmb_price='--';
                    r.rmb_discounted_price='--';
                  }
                }
                else{
                  r.discounted_price='--';
                  r.price='--';
                  r.rmb_price='--';
                  r.rmb_discounted_price='--';
                }
              }
              else{
                r.discounted_price='--';
                r.price='--';
                r.rmb_price='--';
                r.rmb_discounted_price='--';
              }
            }
          }
          return r;
        },
      merchantPriceInfo(){
        return m=>{
          let r = {
            price:'',
            discounted_price:'',
            isInShop:true,
            currency:'',
            currency_symbol:'',
            rmb_price:'',
            rmb_discounted_price:'',
            rmb_currency:'CNY',
            rmb_currency_symbol:'￥'
          };
          if(m.stockMetrix){
            let keys = Object.keys(m.stockMetrix)
            if(this.selectGoodInfo && keys.length>0){
              let default_spec = keys[0];
              let o = m.stockMetrix[default_spec];
              let spec = this.selectGoodInfo['select_'+this.goodDetail.vice_param];
              if(spec)
                o = m.stockMetrix[spec];
              console.log('computed',m.name,o)
              if(o){
                let o_sku = o[this.selectGoodInfo.sku];
                if(o_sku){
                  let p = o_sku.discounted_price;
                  if(p!='--' && p!='-9999.00'){
                    r.price = o_sku.price;
                    r.discounted_price = o_sku.discounted_price
                    r.currency = m.default_currency
                    r.currency_symbol = m.default_currency_symbol
                    r.rmb_price = (parseFloat(r.price)*m.currencyRate).toFixed(2)
                    r.rmb_discounted_price = (parseFloat(r.discounted_price)*m.currencyRate).toFixed(2)
                    r.rmb_currency = 'CNY'
                    r.rmb_currency_symbol = '￥'
                  }
                  else{
                    r.discounted_price='--';
                    r.price='--';
                    r.rmb_price='--';
                    r.rmb_discounted_price='--';
                  }
                }
                else{
                  r.discounted_price='--';
                  r.price='--';
                  r.rmb_price='--';
                  r.rmb_discounted_price='--';
                }
              }
              else{
                r.discounted_price='--';
                r.price='--';
                r.rmb_price='--';
                r.rmb_discounted_price='--';
              }
            }
            else{
              r.discounted_price='--';
              r.price='--';
              r.rmb_price='--';
              r.rmb_discounted_price='--';
            }
          }
          return r
        }
      },
      canHidden(){
        let hn = this.filterSameGoods.filter((i)=>{
          return i.isInShop == false
        })
        return this.filterSameGoods.length>this.hPNumberLimit && hn.length>this.hNNumberLimit;
      },
			computedStock() {
				return merchant => {
					if (!this.readyConfirm) {
						return false
					}
					if (!merchant.stockMetrix) {
						return false
					}
					if (this.isOnlyPrim) {
						if (!merchant.stockMetrix['all']) {
							return true
						}
						if (!merchant.stockMetrix['all'][this.selectGoodInfo.sku]) {
							return true
						}
						if (merchant.stockMetrix['all'][this.selectGoodInfo.sku].availability == 0) {
							return true
						} else
							return false
					} else {
						let s = this.selectGoodInfo['select_'+this.goodDetail.vice_param]
						if(s.split('.').length>2)
							s=s.replace(/\./g,'*')		
						if (!merchant.stockMetrix[s])
							return true
						if (!merchant.stockMetrix[s][this.selectGoodInfo.sku])
							return true
						if (merchant.stockMetrix[s][this.selectGoodInfo.sku]
							.availability == 0)
							return true
						else
							return false
					}
				}
			}
	},
  async mounted() {
    this.get_category_list();
    localStorage.removeItem('units');
    if(localStorage.getItem('units')){
      this.units = JSON.parse(localStorage.getItem('units'));
      this.getDetail();
    }
    else{
      await this.get_units(this);
      this.getDetail();
    }
  },
  methods:{
    getStyle(m){
      let vice_class = new Map();
      if(m.id==this.selectMerchant_ID)
        vice_class.set('borderColor','#333')
      else
        vice_class.set('borderColor','transparent')
    },
    generateSizeTable() {
				this.mul_s_table = []
				const findIdx = (str) => {
					let reg = /<table class="/g
					var count = str.match(reg).length;
					var positions = [];
					str.replace(reg, function(match, index) {
						let s = str.substring(index + 14)
						let t = s.indexOf('\"')
						let name = s.substring(0, t)
						positions.push({
							idx: index,
							name: name
						});
						return match;
					});
					return positions
				}
				let st_idx = this.selectGoodInfo.description.indexOf('<div class="size_table"');
				if (st_idx > -1) {
					let t_content = this.selectGoodInfo.description.substring(st_idx)
					let tab_name = t_content.indexOf('<table class="')
					if (tab_name > -1) {
						let p = findIdx(t_content)
						p.forEach((i, index) => {
							let c = ''
							if (index < p.length - 1)
								c = t_content.substring(i.idx, p[index + 1].idx)
							else
								c = t_content.substring(i.idx)
							c = c.replace(/<table class="/g, '<table class="c_table ').replace('<tbody>', '')
								.replace('</tbody>', '').replace(/<tr/g, '<tr class="s_tr"').replace(/<th>/g,
									'<th class="s_td">').replace(/<td/g, '<td class="s_td"')
							this.mul_s_table.push({
								name: i.name,
								c: c
							})
						})
						this.goodsDetail.description = this.goodsDetail.description.substring(0, st_idx)
					} else {
						this.goodsDetail.description = this.goodsDetail.description.replace(/<table/g,
							'<table class="c_table"').replace('<tbody>', '').replace('</tbody>', '').replace(/<tr/g,
							'<tr class="s_tr"').replace(/<th>/g, '<th class="s_td">').replace(/<td/g,
							'<td class="s_td"')
					}
				}
		},
    handleDetail(){
      let url = '/product?id='+this.productId;
      window.open(url)      
    },
    handleImageLoad(event,index,width) {
      if(width)
        this.containerWidth=400;
      else if(index==0){
        const img = event.target;
        const container = this.$refs.imgcontainer;
        const actualHeight = container.clientHeight;
        const aspectRatio = img.naturalWidth / img.naturalHeight;
        this.containerWidth = actualHeight * aspectRatio;
      }
    },
    caroulChange(currentIndex) {
      this.imageIndex = currentIndex
    },
    handleImageError(e){
      console.log('error',e);
      e.target.src=require('@/assets/images/joyLogoL.png');
      e.target.onerror = null;
    },
    async getDetail(){
      let data = {
        id:this.productId,
        source:'web'
      }
      let res = await api.getGoodsDetailById(this,data)
      res = res.body
      if (res.status == 'ok') {
        this.goodDetail = res.result;
        this.goodDetail.images = this.goodDetail.image_list.map((item)=>{
          return item.small
        })
        if(this.goodDetail.vice_param)
          this.vice_arr = this.goodDetail.vice_param.split('|');
        
        let unique_param_list = this.goodDetail.unique_param_list;
        if(unique_param_list && unique_param_list.length){
          let unique_param = this.goodDetail.unique_param.replace('_list','');
          let uniqIndex = this.goodDetail.sort_param_list.indexOf(unique_param);
          this.groupName = unique_param_list.find((i)=>i!=unique_param)?unique_param_list.find((i)=>i!=unique_param):'';
          let groupIndex = this.goodDetail.sort_param_list.indexOf(this.groupName);
          this.isGroupBehind = uniqIndex>groupIndex;
        }
        this.getSameGoods();     
      }
    },
    async getSameGoods(){
      let data = {
        current_good_id:this.productId,
        include_self:1
      }
      let res = await api.getSameGoods(this,data);
      res = res.body;
      this.sameGoods = res.result
      this.sameGoods.forEach((g)=>{
        g['images'] = g['image_list'].map((i)=>{
          return i.small
        })
        for(let i=0;i<this.vice_arr.length;i++){
          g['real_'+this.vice_arr[i]+'_list']=[];
          g[this.vice_arr[i]+'_list'].forEach((v)=>{
            let o = {
              value:v.value
            }
            if(v.value.split('.').length>2)
              o.showValue = v.value.replace(/\./g,'*');
            else
              o.showValue = v.value;
            o.available = true;
            o.isShow = false;
            g['real_'+this.vice_arr[i]+'_list'].push(o);
          })
        }
        g.isInShop = true;
        g.merchant_info_list.forEach((gm)=>{
          gm.flag = `https://pic.joyorders.com/country/`+gm.country.toLowerCase()+'.png';;
          gm.isInShop = true;
          gm.loadStatus = false;
          let b = this.totalMerlist.findIndex((m)=>{
            return m.id == gm.id
          })
          if(b==-1)
            this.totalMerlist.push(gm);
        })

        if(this.groupName){
          g[this.groupName]=g[this.groupName+'_list'][0].value;
          if(this.groups.indexOf(g[this.groupName])==-1)
            this.groups.push(g[this.groupName])
        }
      })
      if(this.groupName){
        this.curGroupName = this.goodDetail[this.groupName+'_list'][0];
      }
      this.selectGoodInfo = this.sameGoods.find((s)=>{
        return s.id == this.productId;
      })
      if(this.selectGoodInfo){
        let default_m_id = this.selectGoodInfo.default_merchant_id;
        if(this.merchantId)
          default_m_id=this.merchantId
        this.selectMerchant_ID = default_m_id;
        let res = await api.getMerchantDetail(this,{id:this.selectMerchant_ID});
        this.selectMerchant = res.body.result;

        this.selectMerchant.flag = `https://pic.joyorders.com/country/`+this.selectMerchant.country.toLowerCase()+'.png';
        this.selectMerchant.isInShop = true;
        this.selectMerchant.loadStatus = true;
        this.selectMerchant.direct_delivery_transport_amount_template_full_list.forEach((l)=>{
          l.flag = `https://pic.joyorders.com/country/`+l.receiving_area.toLowerCase()+'.png';;
        });
        this.goodDetailReady=true;
        this.setPrimarySpec(this.selectGoodInfo,true,true);
      }
    },
    getSpecName(spec){
      if(spec.indexOf('_list')==-1)
        spec=spec+'_list';
      let key = KEYS.find((k)=>{
        return k['key']==spec
      })
      return key!=null?key.name:''
    },
    getPrimaryText(m){
      let t = m.unique_param;
      switch(t){
        case 'color_list':
          return '颜色';
        case 'size_list':
          if(m.category_list && m.category_list.length){
            let sizeVolumn = this.sizeVolumnJudge(m.category_list)
            return sizeVolumn == 1? '尺码':'容量'
          }
          else
            return '尺码';
        default:
            return '尺码';
      }
    },
    checkIsOnlyPrim(){
      let r = true;
      this.vice_arr.forEach((v)=>{
        if(this.selectGoodInfo[v+'_list'].length>0)
          r = false;
      })
      return r
    },
    isCommonImageUrl() {
      let url = '';
      if(this.selectGoodInfo.enable_alternate_images=='1'){
        if(this.selectGoodInfo.alternate_image_list.length)
          url = this.selectGoodInfo.alternate_image_list[0].small;
      }
      else{
        if(this.selectGoodInfo.images.length)
          url = this.selectGoodInfo.images[0]
      }
      if(url){
        const pathWithoutParams = url.split('?')[0].split('#')[0];
        const extension = pathWithoutParams.split('.').pop().toLowerCase();
        const commonImageExtensions = ['jpg', 'jpeg', 'png', 'svg', 'bmp'];
        this.isNoSpecialImage = commonImageExtensions.includes(extension);
      }
      else
        this.isNoSpecialImage = true;
    },
    setPrimarySpec(item,need_vice_list,need_confirm_inshop){
      if(this.first_load==false && this.selectGoodInfo.id == item.id)
        return;
      this.first_load=false;
      this.selectGoodInfo=item;
      this.isCommonImageUrl();
      this.isOnlyPrim=this.checkIsOnlyPrim();
      //this.generateSizeTable();
      if(this.merchantList.length==0){
        item.merchant_info_list.forEach((m)=>{
          m.isShow=true
          this.merchantList.push(m);
        })
      }
      else{
        item.merchant_info_list.forEach((m)=>{
          let idx = this.merchantList.findIndex((mer)=>{
            return mer.id == m.id
          })
          if(idx==-1)
            this.merchantList.push(m);
        });
        this.merchantList.forEach((m)=>{
          let idx = item.merchant_info_list.findIndex((mer)=>{
            return mer.id==m.id
          })
          if(idx==-1)
            m.isShow=false;
          else
            m.isShow=true;
        })
      }
      this.merchantListSort(this.merchantList,this.selectGoodInfo.default_merchant_id);
      this.generateSizeTable();
      this.generateOtherM();
      /*this.reqs.forEach((r)=>{
        r.abort()
      })
      this.otherMerchantReqs.forEach((r)=>{
        r.abort()
      })*/

      let m =null
      if(this.selectMerchant_ID){
        m = this.merchantList.find((i)=>{
          return i.id==this.selectMerchant_ID
        })
      }
      if(m!=null && m.isShow==false){
        let new_m = this.merchantList.find((i)=>{
          return i.id==this.selectGoodInfo.default_merchant_id
        })
        if(new_m)
          this.setMerchant(new_m)
      }
      else{
        this.merchantList.forEach((m)=>{
          if(m.isShow==true)
            this.handleRequest(m,need_vice_list,need_confirm_inshop)
        })
      }
    },
    merchantListSort(list,id){
      let index = list.findIndex(x => x.id == id)
			let a = list.splice(index, 1)
			list.unshift(a[0])
    },
    async get_stock_status_by_vice_param(m,spec,need_real_vice_list,need_confirm_inshop){
      console.log('merchant',m.id,this.selectMerchant.id);
      if(m.id!=this.selectMerchant.id){
        m.loadStatus = true;
        let obj = {
          merchant_id: m.id,
          good_id:this.selectGoodInfo.id
        }
        if(spec){
          obj.vice_param=this.goodDetail.vice_param;
          obj.value=spec;
        }
        const handleOtherMerchant = (res)=>{     
          //console.log('other',r);
          //this.$set(m,'loadStatus',false);
          m.loadStatus=false;
          //let res = r.data?r.data:{status:'error'};
          if(res.status=='ok' && res.result){
            let data = {};
            try{
              data = res.result.data;
            }
            catch(e){
              data=null;
            }
            if(data!=null){
              let default_subkeyvalue='';
              let res_data={}
              for(let k in data){
                let p = k;
                if(k.split('.').length>2){
                  p=k.replace(/\./g,'*')
                }
                res_data[p]=data[k];
              }
              if(this.selectGoodInfo)
                default_subkeyvalue=Object.keys(res_data)[0];
              m.currentRate = parseFloat(res.result.currency_rate);
              m.stockMetrix = {}
              m.stockMetrix = res_data;
              let result = spec?res_data[spec]:res_data[default_subkeyvalue];
              if(need_confirm_inshop){
                if(result!=null)
                  m.isInShop=true
                else
                  m.isInShop=false
              }
            }
            else{
              m.stockMetrix=null;
              if(need_confirm_inshop)
                m.isInShop=false;
            }
          }
          else{
            m.stockMetrix=null;
            if(need_confirm_inshop)
              m.isInShop=false;
          }
          this.$forceUpdate();
          console.log('computed1',m.name,m.stockMetrix)
        }

        let domain = m.crawler_subdomain && m.support_realtime=='1' && m.enable_realtime=='1'?m.crawler_subdomain:default_crawler;
        let url = `https://${domain}.joyorders.com/api/realtime.php?api=get_product_variation`;
        let url_db = `https://${domain}.joyorders.com/api/realtime.php?api=get_product_variation_by_db`

        let res = await api.post(this, {
          path: 'realtime.php',
          api: 'get_product_variation',
          subdomain:domain,
          data: obj
        })
        res = res.body
        handleOtherMerchant(res)
      }
      else{
        m.loadStatus=true;
        this.selectMerchant.loadStatus=true;
        m.stockMetrix=null;
        let obj = {
          merchant_id:m.id
        }
        if(spec){
          obj.vice_param=this.goodDetail.vice_param;
          obj.value=spec;
        }
        let spu_map = this.goodDetail.same_spu_info_map[m.id];
        this.priceGroup = [];
        this.showPriceGroup = [];
        this.price_map = new Map();
        spu_map.forEach(async (s)=>{
          let skulist = s.sku_list;
          let isInSkulist = false;
          if(this.selectGoodInfo && this.selectMerchant){
            isInSkulist = skulist.indexOf(this.selectGoodInfo.sku)>-1;
            if(isInSkulist && this.selectMerchant.support_vice_param_driver=='1'){
              obj.good_id=this.selectGoodInfo.id
            }
            else{
              obj.good_id=this.goodDetail.sku_good_id_map[s.sku_list[0]]
            }
          }
          const handleData = (r)=>{
            const handlePriceGroup = ()=>{
              this.priceGroup.forEach((item)=>{
                if(!this.price_map.has(item.discounted_price)){
                  this.price_map.set(item.discounted_price,item)
                }
              });
              this.showPriceGroup=Array.from(this.price_map.values());
              //console.log('price',this.showPriceGroup,this.priceGroup,this.price_map)
              this.showPriceGroup.sort((a,b)=>{
                let a_p = a.discounted_price;
                let b_p = b.discounted_price;
                if(a_p=='--')
                  return 1;
                else if(b_p=='--')
                  return -1;
                else
                  return parseFloat(b.discounted_price)-parseFloat(a.discounted_price);
              })
            }

            if(isInSkulist){
              m.loadStatus=false;
              this.selectMerchant.loadStatus=false;
            }
            //let res = r.data?r.data:{status:'error'};
            if(res.status=='ok' && res.result){
              let data = {};
              try{
                data = res.result.data;
              }
              catch(e){
                data=null;
              }
              if(data!=null){
                let default_subkeyvalue='';
                let res_data = {};
                for(let k in data){
                  let p = k;
                  if(k.split('.').length>2)
                    p=k.replace(/\./g,'*');
                  res_data[p]=data[k];
                }
                if(this.selectGoodInfo){
                  default_subkeyvalue=Object.keys(res_data)[0];
                  let o = res_data[default_subkeyvalue];
                  skulist.forEach((s)=>{
                    let idx = this.sameGoods.findIndex((g)=>{
                      return g.sku==s
                    })
                    if(o==null){
                      this.sameGoods[idx].isInShop=false;
                    }
                    else if(o[s]==null)
                       this.sameGoods[idx].isInShop=false;
                    else
                       this.sameGoods[idx].isInShop=true;
                  })
                }
                m.currentRate=parseFloat(res.result.currency_rate);
                this.selectMerchant.currentRate=m.currentRate;
                if(m.stockMetrix==null)
                  m.stockMetrix={}
                for(let k in res_data){
                  if(m.stockMetrix[k]==null)
                    m.stockMetrix[k]={}
                  for(let j in res_data[k]){
                    if(skulist.indexOf(j)>-1){
                      m.stockMetrix[k][j]=res_data[k][j];
                      let ob = res_data[k][j];
                      if(ob.price=='-9999.00' || ob.price=='-9999'){
                        ob.price='--';
                        ob.discounted_price='--';
                      }
                      this.priceGroup.push({
                        price:ob.price,
                        discounted_price:ob.discounted_price,
                        rmb_discounted_price:ob.discounted_price!='--'?(parseFloat(ob.discounted_price)*m.currentRate).toFixed(2):'--'
                      })
                    }
                  }
                }

                handlePriceGroup();
                this.selectMerchant.stockMetrix=m.stockMetrix;
                if(this.selectGoodInfo && this.selectMerchant){
                  if(this.selectMerchant.need_vice_param=='1'){
                    let kk = this.selectMerchant.id+'-'+this.selectGoodInfo.sku;
                    if(spec)
                      kk=kk+'-'+spec;
                    this.validT[kk]={
                      validTime:res.result.validity_period
                    }
                    this.cd = setInterval(()=>{
                      if(this.validT[kk]!=null){
                        let t = this.validT[kk].validTime;
                        t--;
                        if(t<=0){
                          clearInterval(this.cd);
                          return;
                        }
                      }
                      else
                        clearInterval(this.cd);
                    },1000)
                  }
                  else{
                    skulist.forEach((s)=>{
                      let kk = this.selectMerchant.id+'-'+s;
                      if(spec)
                        kk=kk+'-'+spec;
                      this.validT[kk]={
                        validTime:res.result.validity_period
                      }
                      this.cd = setInterval(()=>{
                        if(this.validT[kk]!=null){
                          let t = this.validT[kk].validTime;
                          t--;
                          if(t<=0){
                            clearInterval(this.cd);
                            return;
                          }
                        }
                        else
                          clearInterval(this.cd);
                      },1000)
                    })
                  }
                }
                if(need_real_vice_list){
                  skulist.forEach((s)=>{
                    let idx = this.sameGoods.findIndex((g)=>{
                      return g.sku == s
                    })
                    for(let i=0;i<this.vice_arr.length;i++){
                      let temp = this.sameGoods[idx]['real_'+this.vice_arr[i]+'_list'];
                      for(let p in res_data){
                        let o = res_data[p][s]
                        if(o!=null){
                          if(m.stockMetrix[p][s]!=null){
                            let t = p.split('-');
                            let vice_index = temp.findIndex((r)=>{
                              return r.showValue==t[i]
                            })
                            if(vice_index==-1){
                              let vice = {
                                value:t[i],
                                showValue:t[i],
                                isShow:true
                              }
                              if(t[i].split('*').length>2)
                                vice.value = t[i].replace(/\*/g,'.');
                              this.sameGoods[idx]['real_'+this.vice_arr[i]+'_list'].push(vice);
                            }
                            else
                              this.sameGoods[idx]['real_'+this.vice_arr[i]+'_list'][vice_index].isShow=true;
                          }
                        }
                        else{
                          if(this.sameGoods[idx]['real_'+this.vice_arr[i]+'_list']!=null){
                            this.sameGoods[idx]['real_'+this.vice_arr[i]+'_list'].forEach((i)=>{
                              i.isShow=true
                            })
                          }
                        }
                      }
                    }
                  })
                }
                skulist.forEach((s)=>{
                  let idx = this.sameGoods.findIndex((g)=>{
                    return g['sku']==s
                  })
                  if(this.vice_arr.length>1){
                    if(this.multipleStockMetrix[m['id']==null])
                      this.multipleStockMetrix[m['id']]=[];
                    for(let k in m.stockMetrix){
                      let obj = {}
                      let k_arr = k.split('|');
                      for(let i=0;i<this.vice_arr.length;i++){
                        obj[this.vice_arr[i]]=k_arr[i];
                      }
                      let sku = this.selectGoodInfo.sku;
                      if(m.stockMetrix[k][sku]){
                        obj.available=m.stockMetrix[k][sku].availability==1?true:false;
                      }
                      else
                        obj.available=false;
                      this.multipleStockMetrix[m.id].push(obj);
                    }
                    let arr = this.multipleStockMetrix[m.id];
                    for(let i=0;i<this.vice_arr.length;i++){
                      this.sameGoods[idx]['real_'+this.vice_arr[i]+'_list'].forEach((r)=>{
                        let temp = arr.filter((a)=>{
                          return a[this.vice_arr[i]]==r.value && a.available==true
                        })
                        if(temp.length){
                          r.available=true;
                        }
                        else
                          r.available=false;
                      })
                    }
                  }
                  else{
                    this.sameGoods[idx]['real_'+this.vice_arr[0]+'_list'].forEach((r)=>{
                      if(r.isShow==true){
                        if(m.stockMetrix[r.showValue]==null)
                          r.available=false;
                        else{
                          let temp = m.stockMetrix[r.showValue][s];
                          if(temp!=null)
                            r.available = temp.availability==1?true:false;
                          else
                            r.available = false;
                        }
                      }
                    })
                  }
                })
              }
              else{
                this.priceGroup.push({
                  price:'--',
                  discounted_price:'--',
                  rmb_discounted_price:'--'
                })
                handlePriceGroup();
                m.stockMetrix=null;
                skulist.forEach((s)=>{
                  let idx = this.sameGoods.findIndex((g)=>{
                    return g.sku==s
                  })
                  for(let i=0;i<this.vice_arr.length;i++){
                    this.sameGoods[idx]['real_'+this.vice_arr[i]+'_list'].forEach((r)=>{
                      r.available=false
                      r.isShow=true
                    })
                  }
                  this.sameGoods[idx].isInShop=false;
                })
              }
            }
            else{
              this.priceGroup.push({
                  price:'--',
                  discounted_price:'--',
                  rmb_discounted_price:'--'
              })
              handlePriceGroup();
              m.stockMetrix=null;
              skulist.forEach((s)=>{
                let idx = this.sameGoods.findIndex((g)=>{
                  return g.sku==s
                })
                for(let i=0;i<this.vice_arr.length;i++){
                  this.sameGoods[idx]['real_'+this.vice_arr[i]+'_list'].forEach((r)=>{
                    r.available=false
                    r.isShow=true
                  })
                }
                this.sameGoods[idx].isInShop=false;
              })
            }
            this.$forceUpdate();
          }
          let domain = m.crawler_subdomain && m.support_realtime=='1' && m.enable_realtime=='1'?m.crawler_subdomain:default_crawler;
          let url = `https://${m.crawler_subdomain!='' && m.support_realtime=='1' && m.enable_realtime=='1'?m.crawler_subdomain:default_crawler}.joyorders.com/api/get_real_time_data`;

          let res = await api.post(this, {
            path: 'realtime.php',
            api: 'get_product_variation',
            subdomain:domain,
            data: obj
          })
          res = res.body
          handleData(res)
        })
      }
    },
    async setMerchant(m){
      if(this.selectMerchant!=null){
        if(m.id==this.selectMerchant.id)
          return;
        this.selectMerchant_ID=m.id;
        this.validT={};

        let res = await api.getMerchantDetail(this,{id:this.selectMerchant_ID});
        this.selectMerchant = res.body.result;

        this.selectMerchant.flag = `https://pic.joyorders.com/country/`+this.selectMerchant.country.toLowerCase()+'.png';
        this.selectMerchant.isInShop = true;
        this.selectMerchant.loadStatus = true;
        this.selectMerchant.direct_delivery_transport_amount_template_full_list.forEach((l)=>{
          l.flag = `https://pic.joyorders.com/country/`+l.receiving_area.toLowerCase()+'.png';;
        });

        this.merchantList.forEach((m)=>{
            if(m.isShow)
              this.handleRequest(m,true,true);
        })
      }
    },
    handleRequest(m,need_vice_list,need_confirm_inshop){
      let m_id = m.id;
      let spec = this.generateViceSpec();
      if(spec && spec.split('.').length>2)
        spec.replace(/\./,'*');
      if(this.selectGoodInfo){
        let isExpired = this.checkIsExpire(this.selectGoodInfo.sku,m_id,spec)
        console.log('test',isExpired,m_id);
        if(isExpired){
          this.multipleStockMetrix[m_id]=[];
          this.get_stock_status_by_vice_param(m,spec,need_vice_list,need_confirm_inshop);
        }
        else{
          let spu_map = this.goodDetail.same_spu_info_map[m.id];
          let totalskulist = [];
          spu_map.forEach((s)=>{
            totalskulist = totalskulist.concat(s.sku_list);
          })
          this.sameGoods.forEach((g)=>{
            if(totalskulist.indexOf(g.sku)>-1)
              g.isInShop=true
            else
              g.isInShop=false
          })
        }
      }
    },
    generateOtherM(){
      this.otherMerList=[]
      this.totalMerlist.forEach((m)=>{
        let i = this.merchantList.filter((i)=>{
          return i.isShow
        }).findIndex((m_i)=>{
          return m.id == m_i.id
        })
        if(i==-1)
          this.otherMerList.push(m);
      })
    },
    checkOnlyPrim(){
      let r = true;
      this.vice_arr.forEach((v)=>{
        if(this.selectGoodInfo[v+'_list'].length)
          r = false;
      })
      return r
    },
    checkIsExpire(sku,merchant,spec){
      if(this.selectMerchant){
        let kk = (this.selectMerchant.need_vice_param=='0' || spec=='')?(merchant+'-'+sku):(merchant+'-'+sku+'-'+spec);
        return this.validT[kk]==null || this.validT[kk].validTime<=0
      }
      else
        return false
    },
    setSpec(spec,item){
      spec = spec.replace('_list','');
      if(item.showValue == this.selectGoodInfo['select_'+spec])
         this.$set(this.selectGoodInfo,'select_'+spec,null)
      else
        this.$set(this.selectGoodInfo,'select_'+spec,item.showValue)
      this.$forceUpdate()
      if(this.selectGoodInfo && this.selectMerchant){
        if(this.vice_arr.length>1){
          let r =false;
          for(let i=0;i<this.vice_arr.length;i++){
            if(this.selectGoodInfo['select_'+this.vice_arr[i]]==null)
              r=true
          }
          if(r) return;
        }
        let s_str = [];
        for(let i=0;i<this.vice_arr.length;i++){
          if(this.selectGoodInfo['select_'+this.vice_arr[i]]!=null)
            s_str.push(this.selectGoodInfo['select_'+this.vice_arr[i]])
        }
        if(s_str.length>1){
          this.selectGoodInfo['select_'+this.goodDetail.vice_param]=s_str.join('|');
        }

        let isExpired = this.checkIsExpire(this.selectGoodInfo.sku,this.selectMerchant.id,s_str.join('|'));
        if(isExpired){
          this.get_stock_status_by_vice_param(this.selectMerchant,s_str.join('|'),false,false);
        }
      }
        
    },
    async get_category_list(){
      let res = await api.get_category_list(this);
      res = res.body;
      this.sizeVolumn = res.result;
    },
    async get_units(){
      let res = await api.get_units(this,{need_cn:1});
      res = res.body;
      this.units = res.result;
      localStorage.setItem('units',this.units)
    },
    generateViceSpec(){
      let spec = [];
      this.vice_arr.forEach((v)=>{
        if(this.selectGoodInfo['select_'+v] && this.selectGoodInfo['select_'+v])
          spec.push(this.selectGoodInfo['select_'+v])
      })
      return spec.length?spec.join('|'):''
    },
    showProductName(p){
      if(p.brand_prefix_cn){
        if(p.name_cn){
          if(p.name_cn.toLowerCase().indexOf(p.brand_prefix_cn)!=0)
            return p.brand_prefix_cn+' '+p.name_cn
          else
            return p.name_cn
        }
        else{
          return p.name
        }
      }
      else{
        return p.name_cn || p.name
      }
    },
    sizeVolumnJudge(c_list){
      try{
        let sv = {};
        for(let i = 0;i<c_list.length;i++){
          sv = this.sizeVolumn.find((x)=>{
            return x.id==c_list[i]
          })
          if(sv && sv.children && i!=c_list.length-1)
            this.sizeVolumn = sv.children
        }
        return parseInt(sv.size_or_volumn)
      }
      catch(e){
        return 1;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .vice-params-item{
    line-height: 30px;
    height:30px;
    cursor: pointer;
    background: #fff;
    padding: 0 10px;
    box-sizing: border-box;
    margin-bottom: 15px;
    margin-right: 8px;
    font-size: 15px;
    color:#333;
    border:1px solid transparent
  }
  .vice-params-item.active{
    border:1px solid #333;
  }
  .vice-params-item.notAvailable{
    color:#aaa;
  }
  .merchant-nostock{
    position: absolute;
		top: 2px;
		right: -14px;
		font-size: 9px;
		background: #ccc;
		color: white;
		width: 50px;
		height: 16px;
		line-height: 16px;
		text-align: center;
		transform: rotate(45deg);
  }
  .merchant-item{
    position: relative;
    height: 60px;
    font-size: 1px;
    width: 100%;
    position: relative;
    overflow: hidden;
    background: #fff;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    border:1px solid transparent;
    cursor: pointer;
    padding:0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }
  .merchant-item .flag{
    width: 22px;
    height: 11.56px;
  }
  .merchant-item.active{
    border:1px solid #333;
  }
  .right-detail-header{
    display: flex;
  }
  .spec-button{
    width:60px;
    height:25px;
    cursor: pointer;
    border:1px solid #333;
    line-height: 25px;
    text-align: center;
  }
  .spec-button.active{
    background-color: #333;
    border: 1px solid transparent;
    color: #fff;
  }
  .right-detail-header-image{
    width:75px;
    height:75px;
    border:1px solid #ccc;
    margin-right:15px;
    cursor: pointer;
  }
  .unique-params-item{
    padding:2px;
    width:80px;
    height:114px;
    margin-right:17px;
    background-color: #fafafa;
    border:1px solid transparent;
    text-align: center;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .unique-params-item.active{
    border:1px solid #333;
  }
  .unique-params-text{
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 29px;
    width: 100%;
    font-size: 10px;
    line-height: 15px;
    color:#333;
    text-align: center;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    word-break: break-all;
  }
  .imgdivwrapper{
    height:100%;
    position: relative;
    &.special{
      height:450px;
    }
  }
  .right-article-detail.popup{
    overflow: auto;
    height:calc(100% - 1px);
  }
  .right-article-detail::-webkit-scrollbar{
    display: none;
  }
  .el-icon-star-on{
    font-size: 28px;
  }
  .el-icon-star-off{
    font-size: 24px;;
  }
  .header {
    border-bottom: 1px solid #d7d7d7;
  }
  .crumbs {
    margin-top: 34px;
    max-width: 1200px;
    margin: 34px auto 10px;
  }
  .main-content {
    padding-top: 70 + 116px;
    .select-shop {
      max-width: 760px;
      margin: 0 auto;
    }
    .publish-task-product {
      max-width: 1140px;
      margin: 0 auto;
    }
  }

  @media screen and (max-width:1024px){
    .main-content {
      padding-top: 50px;
    }
  }
  .article-comment{
    display: flex;
    margin-bottom:16px;
  }
  .product-price{
    &.title{
      font-size: 24px;
    }
    &.discounted{
      color:#ff4650;
    }
  }
  .plh_img_walk{
			  width:100%;
			  height:50%;
			  background-repeat: repeat;
			  background-size:contain;
		  }
      .detail-wrapper{
        display:flex;
        justify-content: center;
      }
      .detail-wrapper.popup{
        height:80vh;
      }
</style>



// WEBPACK FOOTER //
// src/components/ProductDetail.vue